import React from 'react';
import { View } from 'react-native';

import _ from 'lodash';
import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './PlanFeatures.Styles';

const PlanFeatures = ({ images, features, featureTextStyle, ...props }) => {
  const theme = useTheme();
  return (
    <View style={styles.featuresContainer(theme)}>
      {_.map(features, feature => {
        const iconName =
          !_.isEmpty(images) && _.isString(feature.icon) ? images[feature.icon] : feature.icon;
        return (
          <View {...props} style={styles.featureContainer} key={feature.name}>
            <Icon style={styles.featureIcon} name={iconName} type="image" />
            <VFText style={[styles.featureText(theme), featureTextStyle]} i18nKey={feature.name} />
          </View>
        );
      })}
    </View>
  );
};

PlanFeatures.defaultProps = {
  features: [],
};
PlanFeatures.propTypes = {
  features: PropTypes.array,
  featureTextStyle: PropTypes.object,
  images: PropTypes.object,
};
export default PlanFeatures;
